import { GraphQLResult, generateClient } from "aws-amplify/api";
import { UserForResolver } from "db/definitions";
import { recordSentry } from "utils/recordSentry";
import { updateUser } from "../graphql/mutations";

interface QueryResult {
	updateUser: UserForResolver;
}
async function updatedUser(user: Pick<UserForResolver, "id"> & Partial<UserForResolver>): Promise<GraphQLResult<QueryResult> | void> {
	try {
		const client = generateClient({ authMode: "userPool" });
		const result = (await client.graphql({
			query: updateUser,
			variables: {
				input: user,
			},
			authMode: "userPool",
		})) as GraphQLResult<QueryResult>;
		return result;
	} catch (error) {
		recordSentry({ error, msg: "error updating single user:" });
	}
}

export default updatedUser;
